// Version : 0.0.1
// Author : VISHNU
// LastEdit : SHIYAM
// MODFIED DATE : 31-07-2025

import EconomicActivityTypeActionTypes from './economic-activity-type.types';

/** ***************** ADD ECONOMIC ACTIVITY TYPE DETAILS START *********************** */
export const addEconomicActivityTypeDetailsStart = (addData: any) => ({
	type: EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_START,
	payload: addData,
});

export const addEconomicActivityTypeDetailsSuccess = (successData: any) => ({
	type: EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const addEconomicActivityTypeDetailsFailure = (failureData: any) => ({
	type: EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const addEconomicActivityTypeDetailsResponseResetStart = () => ({
	type: EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_RESET,
});

export const addEconomicActivityTypeDetailsResponseChanged = () => ({
	type: EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

/** ***************** UPDATE ECONOMIC ACTIVITY TYPE DETAILS START *********************** */
export const updateEconomicActivityTypeDetailsStart = (updateData: any) => ({
	type: EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_START,
	payload: updateData,
});

export const updateEconomicActivityTypeDetailsSuccess = (successData: any) => ({
	type: EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const updateEconomicActivityTypeDetailsFailure = (failureData: any) => ({
	type: EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const updateEconomicActivityTypeDetailsResponseResetStart = () => ({
	type: EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_RESET,
});

export const updateEconomicActivityTypeDetailsResponseChanged = () => ({
	type: EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

/** ***************** GET ECONOMIC ACTIVITY TYPE LIST START *********************** */
export const getEconomicActivityTypeListStart = (getData: any) => ({
	type: EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_START,
	payload: getData,
});

export const getEconomicActivityTypeListSuccess = (successData: any) => ({
	type: EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_SUCCESS,
	payload: successData,
});

export const getEconomicActivityTypeListFailure = (failureData: any) => ({
	type: EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_FAILURE,
	payload: failureData,
});

export const getEconomicActivityTypeListResponseResetStart = () => ({
	type: EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_RESPONSE_RESET,
});

export const getEconomicActivityTypeListResponseChanged = () => ({
	type: EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_RESPONSE_CHANGED,
});

/** ***************** GET ECONOMIC ACTIVITY TYPE LIST END *********************** */

/** ***************** FETCH ECONOMIC ACTIVITY TYPE DETAILS START *********************** */
export const fetchEconomicActivityTypeDetailsStart = (fetchData: any) => ({
	type: EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_START,
	payload: fetchData,
});

export const fetchEconomicActivityTypeDetailsSuccess = (successData: any) => ({
	type: EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchEconomicActivityTypeDetailsFailure = (failureData: any) => ({
	type: EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchEconomicActivityTypeDetailsResponseResetStart = () => ({
	type: EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_RESET,
});

export const fetchEconomicActivityTypeDetailsResponseChanged = () => ({
	type: EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

/** ***************** DELETE ECONOMIC ACTIVITY TYPE DETAILS START *********************** */
export const deleteEconomicActivityTypeDetailsStart = (deleteData: any) => ({
	type: EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_START,
	payload: deleteData,
});

export const deleteEconomicActivityTypeDetailsSuccess = (successData: any) => ({
	type: EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteEconomicActivityTypeDetailsFailure = (failureData: any) => ({
	type: EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteEconomicActivityTypeDetailsResponseResetStart = () => ({
	type: EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_RESET,
});

export const deleteEconomicActivityTypeDetailsResponseChanged = () => ({
	type: EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

/** ***************** FETCH ALL ECONOMIC ACTIVITY TYPE START *********************** */
export const fetchAllEconomicActivityTypeStart = (fetchEconomicActivityTypes: any) => ({
	type: EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_START,
	payload: fetchEconomicActivityTypes,
});

export const fetchAllEconomicActivityTypeSuccess = (successData: any) => ({
	type: EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_SUCCESS,
	payload: successData,
});

export const fetchAllEconomicActivityTypeFailure = (failureData: any) => ({
	type: EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_FAILURE,
	payload: failureData,
});

export const fetchAllEconomicActivityTypeResponseResetStart = () => ({
	type: EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_RESPONSE_RESET,
});

export const fetchAllEconomicActivityTypeResponseChanged = () => ({
	type: EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL ECONOMIC ACTIVITY TYPE END *********************** */
